import dayjs from '@/localPlugins/dayjs';
import isNil from 'lodash/isNil';
import omit from 'lodash/omit';
import omitBy from 'lodash/omitBy';
import { RRule, RRuleSet } from 'rrule';

export const doOffsetAdjustment = (dateObj, offset) => {
  return dayjs(dateObj).add(offset, 'm').toDate();
};

export const convertAIQPayloadToRRulePayload = (recurrence, localTimeOffset = 0) => {
  return omitBy(omit({
    ...recurrence,
    // Ugly enough that we need to convert to local timezone from UTC due to
    // https://github.com/jkbrzt/rrule/issues/556
    dtstart: doOffsetAdjustment(dayjs(recurrence.dtstart).toDate(), -localTimeOffset),
    until: recurrence.until ? doOffsetAdjustment(dayjs(recurrence.until).toDate(), -localTimeOffset) : undefined,
  }, ['id', 'override_data', 'exclude']), isNil);
};

/**
 * rrule.js wrapper
 * rrule calculate expansion only based on UTC and it becomes tricky when we expand weekly
 * such as every Monday since Monday is different based on locality.
 *
 * The Recurrence wrapper help this out to hide locality conversion and make it compatible
 * with UTC handling.
 */
export class Recurrence {
  constructor() {
    this.offset = new Date().getTimezoneOffset();
    this.ruleSet = new RRuleSet();
  }

  addRule(payload) {
    this.ruleSet.rrule(new RRule(convertAIQPayloadToRRulePayload(payload, this.offset)));
  }

  exdate(isoString) {
    this.ruleSet.exdate(doOffsetAdjustment(dayjs(isoString).toDate(), -this.offset));
  }

  between(start, end) {
    return this.ruleSet.between(start, end).map(newDateTime => {
      return doOffsetAdjustment(newDateTime, this.offset);
    });
  }
}
